import { CLINIC_MANAGEMENT_TYPES } from '../actions/ClinicManagementAction';

const initialState = {
  clinics: [],
  clinicDetails: null,
  allDoctors: [],
  loading: false,
  error: null,
  totalClinics: 0,
  currentPage: 1,
  pageSize: 10
};

const clinicManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLINIC_MANAGEMENT_TYPES.SET_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    case CLINIC_MANAGEMENT_TYPES.SET_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      };

    case CLINIC_MANAGEMENT_TYPES.FETCH_CLINICS:
      return {
        ...state,
        clinics: action.payload.clinics || [],
        totalClinics: action.payload.total || 0,
        error: null
      };

    case CLINIC_MANAGEMENT_TYPES.FETCH_CLINIC_DETAILS:
      return {
        ...state,
        clinicDetails: action.payload,
        error: null
      };

    case CLINIC_MANAGEMENT_TYPES.CREATE_CLINIC:
      return {
        ...state,
        clinics: [...state.clinics, action.payload],
        totalClinics: state.totalClinics + 1,
        error: null
      };

    case CLINIC_MANAGEMENT_TYPES.UPDATE_CLINIC:
      return {
        ...state,
        clinics: state.clinics.map(clinic => 
          clinic.id === action.payload.clinicId 
            ? { ...clinic, ...action.payload.data }
            : clinic
        ),
        clinicDetails: state.clinicDetails?.id === action.payload.clinicId 
          ? { ...state.clinicDetails, ...action.payload.data }
          : state.clinicDetails,
        error: null
      };

    case CLINIC_MANAGEMENT_TYPES.DELETE_CLINIC:
      return {
        ...state,
        clinics: state.clinics.filter(clinic => clinic.id !== action.payload),
        totalClinics: state.totalClinics - 1,
        error: null
      };

    case CLINIC_MANAGEMENT_TYPES.UPDATE_CLINIC_STATUS:
      return {
        ...state,
        clinics: state.clinics.map(clinic => 
          clinic.id === action.payload.clinicId 
            ? { ...clinic, status: action.payload.status }
            : clinic
        ),
        clinicDetails: state.clinicDetails?.id === action.payload.clinicId 
          ? { ...state.clinicDetails, status: action.payload.status }
          : state.clinicDetails,
        error: null
      };

    case CLINIC_MANAGEMENT_TYPES.FETCH_ALL_DOCTORS:
      return {
        ...state,
        allDoctors: action.payload || [],
        error: null
      };

    default:
      return state;
  }
};

export default clinicManagementReducer;
